import { Stack } from '@mui/material';
import Step from '/@/components/bayer/step';
import type { RecommendationSidebarProps } from '/@/types/recommendation-create';

function RecommendationDesktopSidebar({ steps, activeStep, setActiveStep }: RecommendationSidebarProps) {
    return (
        <Stack minWidth={390} borderRight={'1px solid lightgray'} height='100%' overflow='scroll'>
            {steps.map((step, i) => (
                <Step
                    key={step.title}
                    index={i + 1}
                    active={activeStep < i + 1}
                    name={step.sidebarName}
                    onClick={() => setActiveStep(i)}
                    disabled={activeStep < i}
                />
            ))}
        </Stack>
    );
}

export default RecommendationDesktopSidebar;
